import React from 'react';
import { PhoneIcon, MessageSquareTextIcon } from 'lucide-react';
import { FIRM } from '../../lib/constants';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-navy py-16 text-cream lg:py-24" data-id="element-104">
      {/* Perth city skyline across the Swan River — warm, local WA context */}
      <div className="absolute inset-0 opacity-[0.16]" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1608656562960-08b8d1b8f9f9?auto=format&fit=crop&w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden data-id="element-105" />
      <Container className="relative text-center" data-id="element-106">
        <h2 className="mx-auto max-w-3xl font-serif text-3xl font-500 leading-tight sm:text-4xl" data-id="element-107">
          Not sure what to do next? Start with a confidential enquiry.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-cream/70" data-id="element-108">
          Tell us what has happened and we'll help you understand the right next
          step.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-109">
          <Button href={FIRM.phoneHref} variant="primary" size="lg" data-id="element-110">
            <PhoneIcon className="h-5 w-5" data-id="element-111" />
            Call {FIRM.phoneDisplay}
          </Button>
          <Button to="/enquiry" variant="outline" size="lg" className="border-cream/25 text-cream hover:border-cream hover:bg-cream/10" data-id="element-112">
            <MessageSquareTextIcon className="h-5 w-5" data-id="element-113" />
            Send an enquiry
          </Button>
        </div>
        <p className="mt-6 text-sm text-cream/55" data-id="element-114">
          Confidential. Practical. No obligation to explain everything
          perfectly.
        </p>
      </Container>
    </section>;
}